import React from 'react';
import { Col, Row, Tooltip } from 'antd';
import lynnStart from 'src/assets/images/howtoplay/lynnStart.png';
import btnAndroid from 'src/assets/images/btnAndroid.svg';
import btnIos from 'src/assets/images/btnIos.svg';
import { StyledDownloadDesktop } from './styled';
import MotionVisible from 'src/components/MotionVisible';
import { animationVariant, boxItemRightVariant } from 'src/variables/animationVariant';

const DownloadDesktop = () => {
  return (
    <StyledDownloadDesktop>
      <div className="container">
        <Row align="middle" justify="space-between">
          <Col span={13} className="col-text">
            <MotionVisible className="main-title" variants={animationVariant}>
              Let’s Burn To Earn
            </MotionVisible>
            <MotionVisible className="title" variants={animationVariant}>
              With CALO INDOOR
            </MotionVisible>
            <MotionVisible className="download-box flex-start" variants={animationVariant}>
              <div className="btn-download">
                <a
                  href="https://apps.apple.com/us/app/calo-indoor/id6443533828"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={btnIos} alt="download" />
                </a>
              </div>
              <div className="btn-download">
                <a
                  href="https://play.google.com/store/apps/details?id=com.calometaverse.indoor"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={btnAndroid} alt="download" />
                </a>
              </div>
            </MotionVisible>
          </Col>
          <Col span={11} className="col-img">
            <MotionVisible className="box-img" variants={boxItemRightVariant}>
              <img className="img-fluid" src={lynnStart} alt="img" />
            </MotionVisible>
          </Col>
        </Row>
      </div>
    </StyledDownloadDesktop>
  );
};

export default DownloadDesktop;
